import { useEffect, useState } from 'react';

/**
 * The shell's mobile breakpoint. It must stay word-for-word identical to the
 * `@media (max-width: 767px)` block in index.css: the markup and the stylesheet
 * have to flip together, or a viewport between the two thresholds gets one
 * layout's DOM styled by the other's rules.
 */
export const MOBILE_VIEWPORT_QUERY = '(max-width: 767px)';

/** Tracks whether the viewport is currently inside the mobile breakpoint. */
export function useMobileViewport(): boolean {
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia(MOBILE_VIEWPORT_QUERY).matches,
  );

  useEffect(() => {
    const query = window.matchMedia(MOBILE_VIEWPORT_QUERY);
    setIsMobile(query.matches);
    const sync = (event: MediaQueryListEvent) => setIsMobile(event.matches);
    query.addEventListener('change', sync);
    return () => query.removeEventListener('change', sync);
  }, []);

  return isMobile;
}
